export default class HttpRequestService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
  }

  httpRequest(accountId, payload) {
    const url = `${this.#getHttpRequestProxyUrl(accountId)}`;
    return this.$http.post(url, payload);
  }

  #getHttpRequestProxyUrl(accountId) {
    return `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/HttpRequestTest`;
  }
}